import { get, post } from '../../utils/request'

// 主营业务列表
const expandIe = get('/management/heaMainBusiness/api/list')

// 旗下业务列表
const belowIe = get('/management/heaItsBusiness/api/list')

// 发展规划
const developmentIe = get('/management/heaDevPlanning/api/list')
export {
  expandIe,
  developmentIe,
  belowIe
}



// WEBPACK FOOTER //
// ./src/api/expand/expand.js